import ApiService from '../core/api';
import ApiConcurrency from '../core/api-concurrency';
import getGqlClient from '../../../../common/graphql/client';
import getHomecardsQuery from '../../../../common/graphql/queries/homecards';

const AdsQueryApiService = function AdsQueryApiService(
  ApiService,
  ApiConcurrency
) {
  this.api = ApiService;
  this.mapSearchApiService = new ApiConcurrency();
  this.homecardSearchApiService = new ApiConcurrency();
  this.pricingApiService = new ApiConcurrency();
};

AdsQueryApiService.prototype.getSearchMarkersOrderedByRelevance = function getSearchMapMarkersFromFiltersConfiguration(
  filters = '',
  cityId,
  removePreviousCalls
) {
  const route = `/api/fe/marketplace/markers/${cityId}?${filters}`;
  return this.mapSearchApiService.get(route, {}, removePreviousCalls);
};

AdsQueryApiService.prototype.getUnitPrices = function getUnitPrices(
  filters = '',
  cityId,
  removePreviousCalls
) {
  const route = `/api/fe/marketplace/unit-prices/${cityId}?${filters}`;
  return this.pricingApiService.get(route, {}, removePreviousCalls);
};

AdsQueryApiService.prototype.getHomecardsFromIds = function getHomecardsFromIds(
  ids = [],
  locale = ''
  // removePreviousCalls
) {
  // const params = { lang: locale };
  // const rentableUnitIds = ids.join(',');
  // const route = `/api/fe/marketplace/homecards?ids=${rentableUnitIds}`;
  // return this.homecardSearchApiService.get(route, params, removePreviousCalls);
  return getHomecardsQuery(getGqlClient())(ids, locale);
};

export default new AdsQueryApiService(ApiService, ApiConcurrency);
